import styled from 'styled-components';

export const LabelRow = styled.div`
  display: flex;
  align-items: center;
  margin-top: 16px;
  margin-bottom: 4px;
`;
LabelRow.displayName = 'S.LabelRow';

export const Label = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 32px;
`;
Label.displayName = 'S.Label';

export const PasteFrom = styled.div`
  display: flex;
  justify-content: flex-end;
  flex: 1 1 auto;
`;
PasteFrom.displayName = 'S.PasteFrom';
